module.exports = __webpack_public_path__ + "img/feature_8.dccef266.png";